import { SubmissionError } from "redux-form";
import { apiCallAsync } from "components/shared/api";

export const ActionTypes = {
  LoadEventsSuccess: "EVENTS.LOAD.SUCCESS",
  RegisterSuccess: "EVENTS.REGISTER.SUCCESS",
};

export const loadEventsAction = async () => {
  try {
    const r = await apiCallAsync("/tts/events", null, "GET");
    return { type: ActionTypes.LoadEventsSuccess, payload: { eventData: r } };
  } catch (ex) {
    let err = "Unknown error";
    try {
      err = JSON.parse(ex.message).message;
    } catch (ex2) {}
    throw new SubmissionError({
      _error: err,
    });
  }
};

// Registration payloads arrive from EventRegisterForm wrapped in a `data` key,
// with the caller's identity fields alongside. Neither API reads that shape:
// both destructure eventId and friends from the top level, so unwrap here.
//
// The identity fields are dropped deliberately. The platform API takes the user
// from the bearer token and rejects unknown properties, so sending
// userFirstName/userLastName/userEmail would fail the request — and the id it
// trusts is the token's, never the body's.
const REGISTRATION_FIELDS = [
  "eventId",
  "eventPrompt",
  "mailingAddress",
  "poContact",
];

export const registerAction = (data) => async (dispatch, getState) => {
  try {
    const source = data && data.data ? data.data : data || {};
    const body = {};
    REGISTRATION_FIELDS.forEach((field) => {
      if (source[field] !== undefined) body[field] = source[field];
    });
    const r = await apiCallAsync("/tts/events/register", body, "POST");
    return { type: ActionTypes.RegisterSuccess, payload: r };
  } catch (ex) {
    let err = "Unknown error";
    try {
      err = JSON.parse(ex.message).message;
    } catch (ex2) {}
    throw new SubmissionError({
      _error: err,
    });
  }
};
